<template>
    <v-card>
        <v-card-title>
            Estimasi pendalaman per-bidang
        </v-card-title>

        <v-card-text>
            <v-list>
                <v-list-item v-for="(field, idx) in fields" :key="idx">
                    <v-list-item-content>
                        <v-list-item-title
                            :class="{
                                'red--text': field.percentage < midLowerLimit,
                                'orange--text': field.percentage >= midLowerLimit && field.percentage < midUpperLimit,
                                'green--text': field.percentage >= midUpperLimit,
                            }"
                        >
                            {{ field.field }}: {{ field.percentage }}%
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: [ 'chartData' ],

    data: () => ({
        midLowerLimit: 66,
        midUpperLimit: 80,
    }),

    computed: {
        fields() {
            return [...this.chartData]
                .sort((a, b) => {
                    return a.correct_answers / a.total_questions - b.correct_answers / b.total_questions
                })
        }
    }
}
</script>
